module.exports = __webpack_public_path__ + "static/media/about_02.e8508b49.png";